import { Form, Radio, Typography, Row, List, Col, Card } from "antd";
import React from "react";
import { barthelIndexOptions } from "../../../../Options/functionalAsessmentOptions";
import "../PhysioScales.css";

const BarthelIndexItems = ({ handleChange, states, nameKey = null }) => {
  return (
    <div className="barthel-index-surface">
      <List
        className="barthel-index-list"
        grid={{ gutter: [12, 12], xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
        dataSource={barthelIndexOptions}
        style={{ backgroundColor: "transparent", width: "100%" }}
        renderItem={(option) => (
          <List.Item className="barthel-index-list-item">
            <Card size="small" className="barthel-index-card">
              <Row
                className="barthel-index-item-row"
                align="middle"
                justify="space-between"
                gutter={[0, 8]}
              >
                <Col span={24}>
                  <Typography className="barthel-index-label">
                    {option.label}
                  </Typography>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name={nameKey ? [nameKey, option.value] : option.value}
                    style={{ marginBottom: 0 }}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        handleChange(option.value, e.target.value)
                      }
                      className="solid-select-radio barthel-index-buttons"
                      buttonStyle="solid"
                    >
                      <Radio.Button value={0}>0</Radio.Button>
                      <Radio.Button value={5}>5</Radio.Button>
                      {!["bathing", "grooming"].includes(option.value) && (
                        <Radio.Button value={10}>10</Radio.Button>
                      )}
                      {["transfers", "mobility"].includes(option.value) && (
                        <Radio.Button value={15}>15</Radio.Button>
                      )}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default BarthelIndexItems;
